
<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-input v-model="formdata.user" placeholder="请输入商品名称">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.xxx" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="address" label="展示价格" align="center"></el-table-column>
          <el-table-column prop="address" label="创建者" align="center"></el-table-column>
          <el-table-column prop="address" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="address" label="上架时间" align="center"></el-table-column>
          <el-table-column label="操作">
            <!-- <template slot-scope="scope"> -->
              <!-- @click="handleClick(scope.row)" -->
              <el-button type="text" size="small">查看</el-button>
            <!-- </template> -->
          </el-table-column>
        </el-table>
        <div class="table_oper">
          <el-button type="primary" @click="bathdel">批量删除</el-button>
        </div>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "personalGoodsList",
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      multipleSelection: []
    };
  },
  methods: {
    //初始化请求
    search() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 选择表格行
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑
    edit() {},
    // 删除
    del() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 批量删除
    bathdel() {
      let params = {};
      this.axios
        .post(api.url, params)
        .then(response => {
          if (response.data.errorCode == 0) {
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    }
  }
};
</script>